import React from 'react';

interface FixtureBoxProps {
  zoneName: string;
  fixtureIdLabel: string;
  zoneId: string;
  handleFixtureClick?: (zoneName: string, fixtureIdLabel: string, zoneId: string) => void;
  handleKeyPress?: (
    event: React.KeyboardEvent<HTMLDivElement>,
    zoneName: string,
    fixtureIdLabel: string,
    zoneId: string,
  ) => void;
  zoneColors: Record<string, string>;
  getZoneColor: (zoneName: string) => string;
  labelOnTopOfFixture: boolean;
}

const FixtureBox = (props: FixtureBoxProps) => {
  const {
    zoneName,
    fixtureIdLabel,
    zoneId,
    handleFixtureClick,
    handleKeyPress,
    zoneColors,
    getZoneColor,
    labelOnTopOfFixture,
  } = props;

  return labelOnTopOfFixture ? (
    <div data-fixtureId={fixtureIdLabel} className="fixture-container">
      <div>{fixtureIdLabel}</div>
      <div
        className="fixture"
        onClick={() => handleFixtureClick?.(zoneName, fixtureIdLabel, zoneId)}
        onKeyPress={(event) => handleKeyPress?.(event, zoneName, fixtureIdLabel, zoneId)}
        tabIndex={0}
        style={{
          backgroundColor: zoneColors[zoneName] ? zoneColors[zoneName] : getZoneColor(zoneName),
          cursor: 'pointer',
        }}
        role="button"
      >
        {zoneName}
      </div>
    </div>
  ) : (
    <div data-fixtureId={fixtureIdLabel} className="fixture-container">
      <div
        className="fixture"
        onClick={() => handleFixtureClick?.(zoneName, fixtureIdLabel, zoneId)}
        onKeyPress={(event) => handleKeyPress?.(event, zoneName, fixtureIdLabel, zoneId)}
        tabIndex={0}
        style={{
          backgroundColor: zoneColors[zoneName] ? zoneColors[zoneName] : getZoneColor(zoneName),
          cursor: 'pointer',
        }}
        role="button"
      >
        {zoneName}
      </div>
      <div>{fixtureIdLabel}</div>
    </div>
  );
};
export default FixtureBox;
